function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { version } from '../../package.json';
import window from 'global/window';
import document from 'global/document';
import * as Events from '@emav-util/events.js';
import mergeOptions from '@emav-util/merge-options.js';
import * as Fn from '@emav-util/fn.js';
import { createTimeRanges } from '@emav-util/time-ranges.js';
import formatTime, {
    setFormatTime,
    resetFormatTime
} from '@emav-util/format-time.js';
import log, { createLogger } from '@emav-util/log.js';
import * as Dom from '@emav-util/dom.js';
import * as browser from '@emav-util/browser.js';
import * as Url from '@emav-util/url.js';
import { isObject } from '@emav-util/obj';
import computedStyle from '@emav-util/computed-style.js';
import xhr from 'xhr';
import AudioTrack from './tracks/audio-track.js';
import VideoTrack from './tracks/video-track.js';
import EventTarget from './event-target';
import Player from './ultimate-player.js';
var normalizeId = function normalizeId(id) {
    return id.indexOf('#') === 0 ? id.slice(1) : id;
};
function emav(id, options, ready) {
    console.log('emav: >>>>>', id, options);
    var player = emav.getPlayer(id);
    if (player) {
        if (options) {
            log.warn('Player "'.concat(id, '" is already initialised. Options will not be applied.'));
        }
        if (ready) {
            player.ready(ready);
        }
        return player;
    }
    var el = typeof id === 'string' ? Dom.$('#' + normalizeId(id)) : id;
    if (!Dom.isEl(el)) {
        throw new TypeError('The element or ID supplied is not valid. (emav)');
    }
    if (!document.body.contains(el)) {
        log.warn('The element supplied is not included in the DOM');
    }
    options = options || {};
    emav.hooks('beforesetup').forEach(function (hookFunction) {
        var opts = hookFunction(el, mergeOptions(options));
        if (!isObject(opts) || Array.isArray(opts)) {
            log.error('please return an object in beforesetup hooks');
            return;
        }
        options = mergeOptions(options, opts);
    });
    console.log('######', Player.prototype);
    player = new Player(el, options, ready);
    emav.hooks('setup').forEach(function (hookFunction) {
        return hookFunction(player);
    });
    console.log('emav: <<<<<<', id, options);
    return player;
}
emav.hooks_ = {};
emav.hooks = function (type, fn) {
    emav.hooks_[type] = emav.hooks_[type] || [];
    if (fn) {
        emav.hooks_[type] = emav.hooks_[type].concat(fn);
    }
    return emav.hooks_[type];
};
emav.hook = function (type, fn) {
    emav.hooks(type, fn);
};
emav.hookOnce = function (type, fn) {
    emav.hooks(type, [].concat(fn).map(function (original) {
        var wrapper = function wrapper() {
            emav.removeHook(type, wrapper);
            return original.apply(void 0, arguments);
        };
        return wrapper;
    }));
};
emav.removeHook = function (type, fn) {
    var index = emav.hooks(type).indexOf(fn);
    if (index <= -1) {
        return false;
    }
    emav.hooks_[type] = emav.hooks_[type].slice();
    emav.hooks_[type].splice(index, 1);
    return true;
};
emav.VERSION = version;
emav.options = Player.prototype.options_;
emav.getPlayers = function () {
    return Player.players;
};
emav.getPlayer = function (id) {
    var players = Player.players;
    var tag;
    if (typeof id === 'string') {
        var nId = normalizeId(id);
        var player = players[nId];
        if (player) {
            return player;
        }
        tag = Dom.$('#' + nId);
    } else {
        tag = id;
    }
    if (Dom.isEl(tag)) {
        var _tag = tag, _player = _tag.player, playerId = _tag.playerId;
        if (_player || players[playerId]) {
            return _player || players[playerId];
        }
    }
};
emav.getAllPlayers = function () {
    return Object.keys(Player.players).map(function (k) {
        return Player.players[k];
    }).filter(Boolean);
};
emav.players = Player.players;
emav.browser = browser;
emav.TOUCH_ENABLED = browser.TOUCH_ENABLED;
emav.mergeOptions = mergeOptions;
emav.bind = Fn.bind;
emav.registerPlugin = Plugin.registerPlugin;
emav.deregisterPlugin = Plugin.deregisterPlugin;
emav.plugin = function (name, plugin) {
    log.warn('emav.plugin() is deprecated; use emav.registerPlugin() instead');
    return Plugin.registerPlugin(name, plugin);
};
emav.getPlugins = Plugin.getPlugins;
emav.getPlugin = Plugin.getPlugin;
emav.getPluginVersion = Plugin.getPluginVersion;
emav.addLanguage = function (code, data) {
    code = ('' + code).toLowerCase();
    emav.options.languages = mergeOptions(emav.options.languages, _defineProperty({}, code, data));
    return emav.options.languages[code];
};
emav.log = log;
emav.createLogger = createLogger;
emav.createTimeRange = emav.createTimeRanges = createTimeRanges;
emav.formatTime = formatTime;
emav.setFormatTime = setFormatTime;
emav.resetFormatTime = resetFormatTime;
emav.parseUrl = Url.parseUrl;
emav.isCrossOrigin = Url.isCrossOrigin;
emav.EventTarget = EventTarget;
emav.on = Events.on;
emav.one = Events.one;
emav.off = Events.off;
emav.trigger = Events.trigger;
emav.xhr = xhr;
emav.AudioTrack = AudioTrack;
emav.VideoTrack = VideoTrack;
[
    'isEl',
    'isTextNode',
    'createEl',
    'hasClass',
    'addClass',
    'removeClass',
    'toggleClass',
    'setAttributes',
    'getAttributes',
    'emptyEl',
    'appendContent',
    'insertContent'
].forEach(function (k) {
    emav[k] = function () {
        log.warn('emav.'.concat(k, '() is deprecated; use emav.dom.').concat(k, '() instead'));
        return Dom[k].apply(null, arguments);
    };
});
emav.computedStyle = computedStyle;
emav.dom = Dom;
emav.url = Url;
console.log('######', Player.prototype);
export default emav;